import React, { useState, useEffect } from 'react';
import { Box, Paper, Typography, Table, TableBody, TableCell, TableHead, TableRow, Chip, Button, TablePagination } from '@mui/material';
import api from '../../api';

const LeaveAllocationHistory = ({ empId, showMsg }) => {
  const [allocations, setAllocations] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    loadAllocations();
  }, []);

  const loadAllocations = async () => {
    try {
      const allocRes = await api.get('/leave/allocations');
      setAllocations(allocRes.data);
    } catch (err) { console.error(err); }
  };

  const processAction = async (id, action) => {
    try {
      await api.put(`/leave/allocations/approve/${id}?action=${action}`, { approved_by: empId });
      showMsg(`Allocation ${action}D successfully!`);
      loadAllocations();
    } catch (err) { 
      showMsg(err.response?.data?.detail || "Failed", "error"); 
    }
  };

  return (
    <Paper elevation={2} sx={{ p: 3, borderRadius: 2 }}>
      <Typography variant="h6" gutterBottom>Assigned Leave Report</Typography>
      <Table size="small">
        <TableHead sx={{ bgcolor: '#e3f2fd' }}>
          <TableRow>
            <TableCell>Leave</TableCell>
            <TableCell>Days</TableCell>
            <TableCell>Reason</TableCell>
            <TableCell>Target</TableCell>
            <TableCell>Expiry</TableCell>
            <TableCell>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {allocations.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(al => (
            <TableRow key={al.id}>
              <TableCell sx={{ fontWeight: 'bold' }}>{al.leave_type}</TableCell>
              <TableCell>{al.days}</TableCell>
              <TableCell>{al.reason}</TableCell>
              <TableCell><Chip size="small" label={al.assignment_type} /></TableCell>
              <TableCell>{al.expiry_date}</TableCell>
              <TableCell>
                {al.status === 'PENDING' ? 
                  <Button size="small" color="success" onClick={() => processAction(al.id, 'APPROVE')}>Approve</Button> : 
                  <Chip size="small" label={al.status} color="success" />
                }
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <TablePagination 
        component="div" 
        count={allocations.length} 
        page={page} 
        onPageChange={(e, p) => setPage(p)} 
        rowsPerPage={rowsPerPage} 
        onRowsPerPageChange={e => {setRowsPerPage(parseInt(e.target.value, 10)); setPage(0);}} 
      />
    </Paper>
  );
};

export default LeaveAllocationHistory;